import { render, staticRenderFns } from "./ProjectDetails.vue?vue&type=template&id=6f8ba2e4&scoped=true&"
import script from "./ProjectDetails.vue?vue&type=script&lang=js&"
export * from "./ProjectDetails.vue?vue&type=script&lang=js&"
import style0 from "../assets/scss/projectForm.scss?vue&type=style&index=0&id=6f8ba2e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8ba2e4",
  null
  
)

export default component.exports